import { Component, Host, h, Element, Prop } from '@stencil/core';

@Component({
  tag: 'lilu-energy-tooltip',
  styleUrl: 'lilu-energy-tooltip.scss',
  shadow: true,
})

export class LiluEnergyTooltip {

  @Element() el: HTMLElement;

  @Prop() img = '';
  @Prop() alt = '';

  onClick() {
    this.el.style.display = 'none';
  }

  render() {
    return (
      <Host onClick={this.onClick.bind(this)} >
        <div class= 'tooltip' >
          <p class='close'>×</p>
          <div class="img-container">
            <lilu-img src={this.img} alt={this.alt}></lilu-img>
          </div>
        </div>
      </Host>
    );
  }
}
